import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { Box, IconButton, Paper, Typography } from "@mui/material";

import { useDeleteProductFeatureMutation } from "api/memberPortal/features/productFeatures/productFeatures.api";
import { ProductFeature } from "api/memberPortal/features/productFeatures/productFeatures.types";

interface TestedFeatureListItemProps {
  feature: ProductFeature;
  featureId: number;
  featureType: "product" | "pcm";
  onError: (_error: string) => void;
}

const TestedFeatureListItem = ({
  feature,
  featureId,
  featureType,
  onError,
}: TestedFeatureListItemProps) => {
  const [deleteProductFeature, { isLoading }] =
    useDeleteProductFeatureMutation();

  const handleDeleteFeature = async (id: number) => {
    try {
      await deleteProductFeature({
        id,
        ...(featureType === "product"
          ? { product: featureId }
          : { pcm: featureId }),
      }).unwrap();
    } catch {
      onError("Failed to delete feature. Please try again.");
    }
  };

  return (
    <Paper
      key={feature.id}
      elevation={1}
      sx={{
        p: 1.5,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: "white",
        "&:hover": {
          backgroundColor: "grey.50",
        },
      }}
    >
      <Typography variant="body2">{feature.feature_name}</Typography>
      <Box sx={{ display: "flex", gap: 0.5 }}>
        <IconButton
          size="small"
          onClick={() => handleDeleteFeature(feature.id)}
          disabled={isLoading}
          title="Delete"
          sx={{ color: "error.main" }}
        >
          <DeleteOutlineIcon fontSize="small" />
        </IconButton>
      </Box>
    </Paper>
  );
};

export default TestedFeatureListItem;
